import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IPolicy, PolicyType } from '../_models/policy.model';
import { PolicyService } from '../_services/policy.service';
import { SeoService } from '../../_shared/_services/seo.service';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-refund-policy',
    templateUrl: './refund-policy.component.html',
    styleUrls: ['./refund-policy.component.scss'],
    imports: [AsyncPipe]
})
export class RefundPolicyComponent implements OnInit {
  private readonly policyService = inject(PolicyService);
  private readonly seoService = inject(SeoService);

  public policies$!: Observable<Array<IPolicy>>;
  public refund: PolicyType = PolicyType.REFUND;

  ngOnInit(): void {
    this.seoService.createCanonicalUrl('https://mypoolhut.com/policy/refund-policy');
    this.policies$ = this.policyService.policies$;
    this.policyService.loadPolicies();
  }
}
